module.exports = __webpack_public_path__ + "static/img/2-2-普通仅退款.3b682ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-2-普通仅退款.png
// module id = 1314
// module chunks = 0